import io from 'socket.io-client';
import env from '../config/env';

const getSocketUrl = () => {
    // Se estiver rodando no navegador, usa a origem atual (ex: http://localhost:7075)
    // Isso resolve o problema do docker mapping portas diferentes da interna
    if (typeof window !== 'undefined') {
        return window.location.origin;
    }

    if (env.API_BASE_URL) {
        return env.API_BASE_URL.replace('/api', '');
    }
    return 'http://localhost:3001';
};

const socket = io(getSocketUrl());

export default socket;
